<template>
  <Search></Search>
  <Map v-if="dataLoaded === true"></Map>
  <Spinner v-if="dataLoaded === false"></Spinner>
  <ProCard v-if="dataLoaded === true"></ProCard>
  <Pagination v-if="dataLoaded === true && state.displayedAnnuaire.length !== 1"></Pagination>
</template>

<script>
import Map from "./Map.vue";
import Search from "./Search.vue";
import ProCard from "./ProCard.vue";
import Pagination from "./Pagination.vue";
import { getData, getPositions } from "../store";
import { onMounted, ref } from "vue";
import Spinner from "./Spinner.vue";
import { state } from "../store";

export default {
  name: "Widget",
  setup() {
    const dataLoaded = ref(false);

    onMounted(async () => {
      await getPositions();
      await getData();
      dataLoaded.value = true;
    });

    return { dataLoaded, state }
  },
  components: { Search, ProCard, Map, Pagination, Spinner }
}
</script>

<style lang="scss">
</style>
